import { useParams } from "react-router-dom";
import SaveAgendamientoOrdenVisita from "../../components/save-agendamiento-orden-visita/SaveAgendamientoOrdenVisita";
import { useGetAgendamiento } from "@/shared/actions/erp";
import { useLoaders } from "@/shared";

export default function OrdenServicioVisitaAgendamientoPage() {
    const { id } = useParams();
    const {
        data,
        isLoading,
        isRefetching
    } = useGetAgendamiento(id!)

    useLoaders(isLoading || isRefetching);
    console.log('agedamiento', data)
    return <SaveAgendamientoOrdenVisita
        title="Confirmar Visita"
        agendamiento={data?.data}
        enableGestionVenta={false}
    />
}